/* ms-challenge-wann.js
   ------------------------------------------------------------------
   Reiter Planung, Box unter dem Kopf: Umschalter "Etappen & Hotels" /
   "Wann fahren?" (gleitender Knopf) und der Inhalt von "Wann fahren?":
   Stufe, Datum (tippen oder eigener Kalender), Anzeige mit sechs
   Werten, Jahresband mit 36 Abschnitten (Hover = Vorschau, Antippen
   oder Ziehen = festhalten), Saisonklammer unter den Monaten.

   Stufe: gekoppelt mit dem Planer in beide Richtungen
   (ms:planner-tier vom Planer, ms:wann-tier an den Planer).

   Rechenkern: Sonnenstand nach NOAA fuer Wernigerode, Sommerzeit nach
   EU-Regel; jedes Jahr praktisch gleich, deshalb kein Abruf.
   Temperaturen: mittlerer Tageshoechstwert 1991 bis 2020 aus den
   DWD-Tageswerten (TXK) der Stationen 5490 Wernigerode und 722 Brocken.
   Texte aus [data-ms-wann-i18n] (Locales ms.challenge.wann.*).
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var LAT = 51.835, LON = 10.785; // Wernigerode
  /* Mittlerer Tageshoechstwert je Monat (DWD daily/kl/historical, Spalte TXK,
     1991 bis 2020, gerechnet am 22.09.2026). Zum Vergleich das Tagesmittel im
     Juli: Wernigerode 18,4 statt 23,9 Grad. */
  var TEMP = {
    valley: [4.3, 5.2, 8.8, 14.1, 18.2, 21.4, 23.9, 23.8, 19.3, 14.0, 8.4, 5.1],
    summit: [-1.1, -1.0, 1.4, 6.0, 10.1, 13.2, 15.4, 15.3, 11.1, 6.8, 2.9, 0.0]
  };
  /* Saisonfenster [Monat, Tag] bis [Monat, Tag] (Fabian, 22.09.2026) */
  var SEASON = {
    bronze: { from: [2, 11], to: [11, 20], key: 'season_bronze' },
    silber: { from: [3, 1], to: [10, 31], key: 'season_silber' },
    gold: { from: [4, 21], to: [9, 20], key: 'season_gold' }
  };

  /* ---------- Sonnenstand nach NOAA ---------- */
  var rad = Math.PI / 180, deg = 180 / Math.PI;
  function solar(y, m, d) {
    var jd = Date.UTC(y, m - 1, d, 12) / 86400000 + 2440587.5 - LON / 360;
    var T = (jd - 2451545) / 36525;
    var L0 = (280.46646 + T * (36000.76983 + T * 0.0003032)) % 360;
    var M = 357.52911 + T * (35999.05029 - 0.0001537 * T);
    var e = 0.016708634 - T * (0.000042037 + 0.0000001267 * T);
    var C = Math.sin(M * rad) * (1.914602 - T * (0.004817 + 0.000014 * T)) + Math.sin(2 * M * rad) * (0.019993 - 0.000101 * T) + Math.sin(3 * M * rad) * 0.000289;
    var om = 125.04 - 1934.136 * T;
    var lam = L0 + C - 0.00569 - 0.00478 * Math.sin(om * rad);
    var eps0 = 23 + (26 + (21.448 - T * (46.815 + T * (0.00059 - T * 0.001813))) / 60) / 60;
    var eps = eps0 + 0.00256 * Math.cos(om * rad);
    var dec = Math.asin(Math.sin(eps * rad) * Math.sin(lam * rad));
    var yy = Math.pow(Math.tan(eps * rad / 2), 2);
    var eot = 4 * deg * (yy * Math.sin(2 * L0 * rad) - 2 * e * Math.sin(M * rad) + 4 * e * yy * Math.sin(M * rad) * Math.cos(2 * L0 * rad) - 0.5 * yy * yy * Math.sin(4 * L0 * rad) - 1.25 * e * e * Math.sin(2 * M * rad));
    var noon = 720 - 4 * LON - eot;
    function ha(zen) {
      var c = Math.cos(zen * rad) / (Math.cos(LAT * rad) * Math.cos(dec)) - Math.tan(LAT * rad) * Math.tan(dec);
      if (c > 1 || c < -1) return null;
      return Math.acos(c) * deg;
    }
    var h = ha(90.833), hc = ha(96);
    return { rise: noon - 4 * h, set: noon + 4 * h, dawn: hc == null ? null : noon - 4 * hc, dusk: hc == null ? null : noon + 4 * hc };
  }
  function lastSunday(y, m) { var d = new Date(Date.UTC(y, m, 0)); return d.getUTCDate() - d.getUTCDay(); }
  function isDST(y, m, d) {
    if (m < 3 || m > 10) return false;
    if (m > 3 && m < 10) return true;
    if (m === 3) return d >= lastSunday(y, 3);
    return d < lastSunday(y, 10);
  }
  function dayInfo(y, m, d) {
    var s = solar(y, m, d), off = isDST(y, m, d) ? 120 : 60;
    return { y: y, m: m, d: d, dst: off === 120, rise: s.rise + off, set: s.set + off, dawn: s.dawn == null ? null : s.dawn + off, dusk: s.dusk == null ? null : s.dusk + off, len: s.set - s.rise };
  }

  /* ---------- Hilfen ---------- */
  function q(sel, el) { return (el || document).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(s, map) { s = String(s || ''); Object.keys(map).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(map[k]).split('__' + k.toUpperCase() + '__').join(map[k]); }); return s; }
  function jsonOf(sel, el) { try { var t = q(sel, el); return t ? JSON.parse(t.textContent) : null; } catch (e) { return null; } }
  function hm(min) { min = Math.round(min); var h = Math.floor(min / 60), m = min % 60; return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dim(y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); }
  function key(m, d) { return m * 100 + d; }
  function inSeason(t, m, d) { var k = key(m, d); return k >= key(t.from[0], t.from[1]) && k <= key(t.to[0], t.to[1]); }
  function segOf(m, d) { return (m - 1) * 3 + (d <= 10 ? 0 : d <= 20 ? 1 : 2); }
  function slug(v) { v = String(v || '').toLowerCase().trim(); return v === 'silver' ? 'silber' : v; }
  var reduce = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Gleitender Knopf eines Segments: Position aus der gewaehlten Taste */
  function moveThumb(seg) {
    var on = q('[aria-selected="true"], [aria-checked="true"]', seg), th = q('[data-ms-thumb]', seg);
    if (!on || !th || !on.offsetWidth) return;
    th.style.width = on.offsetWidth + 'px';
    th.style.transform = 'translateX(' + on.offsetLeft + 'px)';
  }

  function mount(frame) {
    if (frame.getAttribute('data-ms-wann-ready')) return;
    frame.setAttribute('data-ms-wann-ready', 'true');
    var panel = frame.closest('[data-ms-ct-panel]') || document;
    var T = jsonOf('[data-ms-wann-i18n]', panel) || {};
    var CFG = jsonOf('[data-ms-planung-cfg]', panel) || {};
    var TIER_NAMES = (jsonOf('[data-ms-planung-i18n]', panel) || {}).tiers || { bronze: 'Bronze', silber: 'Silber', gold: 'Gold' };
    var MONTHS = String(T.months_long || '').split(','), MSHORT = String(T.months_short || '').split(','), DOW = String(T.dow || '').split(',');
    var el = function (n) { return q('[data-ms-wann="' + n + '"]', frame); };
    var dec = function (v) { return (v < 0 ? '−' : '') + Math.abs(v).toFixed(1).replace('.', T.dec_sep || ',') + ' °C'; };
    var dur = function (min) { min = Math.round(min); return Math.floor(min / 60) + ' ' + (T.unit_h || 'h') + ' ' + (min % 60) + ' ' + (T.unit_min || 'min'); };

    /* ---------- Umschalter Etappen & Hotels / Wann fahren? ---------- */
    var view = q('[data-ms-pl-view]', panel), views = qa('[data-ms-pl-view-panel]', frame);
    if (!view) return;
    function setView(v) {
      qa('button[data-v]', view).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === v ? 'true' : 'false'); });
      views.forEach(function (p) { p.hidden = p.getAttribute('data-ms-pl-view-panel') !== v; });
      qa('[data-ms-pl-hero]', panel).forEach(function (h) { h.hidden = h.getAttribute('data-ms-pl-hero') !== v; });
      moveThumb(view);
      if (v === 'wann') requestAnimationFrame(relayout);
    }
    view.addEventListener('click', function (e) { var b = e.target.closest('button[data-v]'); if (b) setView(b.getAttribute('data-v')); });

    /* ---------- Zustand ---------- */
    var state = { tier: 'bronze', seg: null, date: null, hover: null };
    var YEAR = new Date().getFullYear() + 1;
    var SEGS = [];
    for (var m = 1; m <= 12; m++) {
      var end = dim(YEAR, m);
      [[1, 10], [11, 20], [21, end]].forEach(function (r) { var mid = Math.round((r[0] + r[1]) / 2); SEGS.push({ m: m, a: r[0], b: r[1], mid: mid, info: dayInfo(YEAR, m, mid) }); });
    }
    var HMIN = 6, HMAX = 17.5;
    var pct = function (lenMin) { return Math.max(4, ((lenMin / 60 - HMIN) / (HMAX - HMIN)) * 100); };

    /* ---------- Band ---------- */
    var barsEl = el('bars'), band = el('band');
    el('months').innerHTML = MSHORT.map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('');
    barsEl.innerHTML = MONTHS.map(function (_, mi) {
      return '<div class="ct-wf__month">' + SEGS.slice(mi * 3, mi * 3 + 3).map(function (s, k) {
        var i = mi * 3 + k, lbl = tpl(T.bar_aria, { from: s.a, to: s.b, month: MONTHS[s.m - 1], hours: dur(s.info.len) });
        return '<button type="button" class="ct-wf__bar" data-i="' + i + '" aria-pressed="false" tabindex="-1" aria-label="' + esc(lbl) + '" style="--h:' + pct(s.info.len).toFixed(1) + '%;--dl:' + (i * 0.012).toFixed(3) + 's"><i></i></button>';
      }).join('') + '</div>';
    }).join('');
    var BARS = qa('.ct-wf__bar', barsEl);
    var TODAY_SEG = (function () { var d = new Date(); return segOf(d.getMonth() + 1, d.getDate()); })();

    function paintTier() {
      var t = SEASON[state.tier] || SEASON.bronze;
      frame.setAttribute('data-tier', state.tier);
      frame.style.setProperty('--wf-c', (CFG.tier_colors && CFG.tier_colors[state.tier]) || 'var(--ct-c)');
      qa('button[data-t]', el('tiers')).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-t') === state.tier ? 'true' : 'false'); });
      moveThumb(el('tiers'));
      var first = -1, last = -1;
      SEGS.forEach(function (s, i) {
        var inS = inSeason(t, s.m, s.a) && inSeason(t, s.m, s.b);
        if (inS) { if (first < 0) first = i; last = i; }
        BARS[i].classList.toggle('in', inS);
      });
      var a = BARS[first].getBoundingClientRect(), b = BARS[last].getBoundingClientRect(), w = barsEl.getBoundingClientRect();
      if (w.width) { el('season').style.left = (a.left - w.left) + 'px'; el('season').style.width = (b.right - a.left) + 'px'; }
      el('season-t').textContent = tpl(T.season_label, { tier: TIER_NAMES[state.tier] || state.tier, season: T[t.key] || '' });
      el('cal-season').textContent = tpl(T.cal_season, { tier: TIER_NAMES[state.tier] || state.tier });
    }

    function verdict(inf) {
      var t = SEASON[state.tier] || SEASON.bronze, name = TIER_NAMES[state.tier] || state.tier;
      var h = inf.len / 60, hf = Math.floor(h), inS = inSeason(t, inf.m, inf.d), bsIn = inSeason(SEASON.bronze, inf.m, inf.d);
      if (state.tier === 'gold') {
        if (!inS) return { off: true, t: h < 12 && bsIn ? T.v_gold_off_short : T.v_gold_off };
        if (h >= 16) return { off: false, t: T.v_gold_ok };
        return { off: false, t: tpl(T.v_gold_in, { h: hf }) };
      }
      if (!inS) return { off: true, t: tpl(T.v_bs_off, { tier: name, season: T[t.key] || '' }) };
      if (h < 12) return { off: false, t: tpl(T.v_bs_short, { tier: name, h: hf }) };
      return { off: false, t: tpl(T.v_bs_in, { tier: name, h: hf }) };
    }
    function whenOf(s) { var k = s.mid <= 5 ? 'early' : s.mid <= 15 ? 'mid' : 'late'; return tpl(T[k], { month: MONTHS[s.m - 1] }); }

    function show(inf, whenText, monthIdx, preview) {
      var v = verdict(inf), t = SEASON[state.tier] || SEASON.bronze, name = TIER_NAMES[state.tier] || state.tier, read = el('read');
      read.classList.toggle('is-off', v.off);
      read.classList.toggle('is-preview', !!preview);
      el('when').textContent = whenText + ':';
      el('say').textContent = v.t;
      var L = Math.round(inf.len);
      el('f-len').innerHTML = Math.floor(L / 60) + ' ' + esc(T.unit_h || 'h') + ' <em>' + (L % 60) + ' ' + esc(T.unit_min || 'min') + '</em>';
      el('f-sunlabel').textContent = tpl(T.f_sun, { zone: inf.dst ? (T.zone_dst || 'MESZ') : (T.zone_std || 'MEZ') });
      el('f-sun').innerHTML = hm(inf.rise) + '<em> – </em>' + hm(inf.set);
      el('f-civ').innerHTML = inf.dawn == null ? '—' : hm(inf.dawn) + '<em> – </em>' + hm(inf.dusk);
      el('f-tlabel').textContent = tpl(T.f_valley, { month: MSHORT[monthIdx] });
      el('f-blabel').textContent = tpl(T.f_summit, { month: MSHORT[monthIdx] });
      el('f-tw').innerHTML = dec(TEMP.valley[monthIdx]) + ' <em>' + esc(T.f_daytime) + '</em>';
      el('f-tb').innerHTML = dec(TEMP.summit[monthIdx]) + ' <em>' + esc(T.f_daytime) + '</em>';
      el('f-season').textContent = tpl(inSeason(t, inf.m, inf.d) ? T.season_yes : T.season_no, { tier: name });
    }
    // Die Auswahl (Datum oder Balken) ist immer die Hauptmarkierung; heute bleibt nur leise erkennbar (is-today).
    // Anzeige und Balkenfarbe wechseln im selben Moment mit derselben Dauer (SWAP_MS, passend zur CSS-Transition).
    var SWAP_MS = 220, lastKey = null, SWAP = ['when', 'say', 'f-len', 'f-sun', 'f-civ', 'f-tw', 'f-tb', 'f-season'];
    function swapIn() {
      if (reduce()) return;
      SWAP.forEach(function (k) { var n = el(k); if (n && n.animate) n.animate([{ opacity: .3 }, { opacity: 1 }], { duration: SWAP_MS, easing: 'ease-out' }); });
    }
    function refresh() {
      BARS.forEach(function (b, i) { b.setAttribute('aria-pressed', i === state.seg ? 'true' : 'false'); b.classList.toggle('is-today', i === TODAY_SEG); b.tabIndex = i === state.seg ? 0 : -1; });
      var key;
      if (state.hover != null) { var hs = SEGS[state.hover]; key = 'h' + state.hover + state.tier; show(hs.info, whenOf(hs), hs.m - 1, true); }
      else if (state.date) { var p = state.date; key = 'd' + p.y + '-' + p.m + '-' + p.d + state.tier; show(dayInfo(p.y, p.m, p.d), tpl(T.on_date, { day: p.d, month: MONTHS[p.m - 1], year: p.y }), p.m - 1); }
      else { var s = SEGS[state.seg]; key = 's' + state.seg + state.tier; show(s.info, whenOf(s), s.m - 1); }
      if (lastKey !== null && key !== lastKey) swapIn();
      lastKey = key;
    }

    /* ---------- Datum: tippen oder Kalender ---------- */
    var dateEl = el('date'), clearEl = el('date-clear');
    function setDate(p) {
      state.date = p; state.hover = null;
      if (p) { state.seg = segOf(p.m, p.d); dateEl.value = pad(p.d) + '.' + pad(p.m) + '.' + p.y; dateEl.classList.remove('is-bad'); clearEl.hidden = false; calCur = { y: p.y, m: p.m }; }
      else { dateEl.value = ''; clearEl.hidden = true; }
      refresh(); if (calOpen) renderCal();
    }
    function pickSeg(i, focus) {
      i = Math.max(0, Math.min(SEGS.length - 1, i));
      state.seg = i; state.date = null; state.hover = null; dateEl.value = ''; dateEl.classList.remove('is-bad'); clearEl.hidden = true;
      refresh();
      if (focus) BARS[state.seg].focus();
    }
    function parseDate(v) {
      var m = /^\s*(\d{1,2})[.\/\-\s](\d{1,2})(?:[.\/\-\s](\d{2,4}))?\s*\.?\s*$/.exec(v);
      if (!m) return null;
      var d = +m[1], mo = +m[2], y = m[3] ? +m[3] : new Date().getFullYear();
      if (y < 100) y += 2000;
      if (mo < 1 || mo > 12 || d < 1 || d > dim(y, mo)) return null;
      return { y: y, m: mo, d: d };
    }
    function commitInput() {
      var v = dateEl.value.trim();
      if (!v) { if (state.date) setDate(null); return; }
      var p = parseDate(v);
      if (!p) { dateEl.classList.add('is-bad'); return; }
      setDate(p);
    }
    dateEl.addEventListener('change', commitInput);
    dateEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commitInput(); closeCal(); } if (e.key === 'Escape') closeCal(); });
    dateEl.addEventListener('input', function () { dateEl.classList.remove('is-bad'); });
    clearEl.addEventListener('click', function () { setDate(null); dateEl.focus(); });

    var cal = el('cal'), calBtn = el('cal-btn'), calOpen = false, calCur = { y: new Date().getFullYear(), m: new Date().getMonth() + 1 };
    function renderCal() {
      var y = calCur.y, m = calCur.m, t = SEASON[state.tier] || SEASON.bronze, today = new Date();
      el('cal-title').textContent = MONTHS[m - 1] + ' ' + y;
      var first = (new Date(Date.UTC(y, m - 1, 1)).getUTCDay() + 6) % 7;
      var html = DOW.map(function (d) { return '<div class="ct-wf__dow">' + esc(d) + '</div>'; }).join('');
      for (var i = 0; i < first; i++) html += '<span class="ct-wf__d ct-wf__d--pad"></span>';
      for (var d = 1; d <= dim(y, m); d++) {
        var cls = 'ct-wf__d' + (inSeason(t, m, d) ? ' in' : '') + (state.date && state.date.y === y && state.date.m === m && state.date.d === d ? ' sel' : '') + (today.getFullYear() === y && today.getMonth() + 1 === m && today.getDate() === d ? ' today' : '');
        html += '<button type="button" class="' + cls + '" data-d="' + d + '">' + d + '</button>';
      }
      el('cal-grid').innerHTML = html;
    }
    function openCal() { calOpen = true; renderCal(); cal.hidden = false; calBtn.setAttribute('aria-expanded', 'true'); }
    function closeCal() { if (!calOpen) return; calOpen = false; cal.hidden = true; calBtn.setAttribute('aria-expanded', 'false'); }
    calBtn.addEventListener('click', function () { calOpen ? closeCal() : openCal(); });
    el('cal-prev').addEventListener('click', function () { calCur.m--; if (calCur.m < 1) { calCur.m = 12; calCur.y--; } renderCal(); });
    el('cal-next').addEventListener('click', function () { calCur.m++; if (calCur.m > 12) { calCur.m = 1; calCur.y++; } renderCal(); });
    el('cal-today').addEventListener('click', function () { var n = new Date(); setDate({ y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate() }); closeCal(); });
    el('cal-grid').addEventListener('click', function (e) { var b = e.target.closest('button[data-d]'); if (!b) return; setDate({ y: calCur.y, m: calCur.m, d: +b.getAttribute('data-d') }); closeCal(); dateEl.focus(); });
    document.addEventListener('pointerdown', function (e) { if (calOpen && !e.target.closest('[data-ms-wann="datefield"]')) closeCal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCal(); });

    /* ---------- Band bedienen: Hover = Vorschau, Klick oder Ziehen = festhalten ---------- */
    function segAt(x) { var best = 0, bd = 1e9; BARS.forEach(function (b, i) { var r = b.getBoundingClientRect(), d = Math.abs(x - (r.left + r.right) / 2); if (d < bd) { bd = d; best = i; } }); return best; }
    var dragging = false;
    function clearHover() { if (state.hover == null) return; state.hover = null; band.classList.remove('is-hover'); BARS.forEach(function (b) { b.classList.remove('is-hov'); }); refresh(); }
    barsEl.addEventListener('pointerdown', function (e) { if (e.button !== 0 && e.pointerType === 'mouse') return; dragging = true; try { barsEl.setPointerCapture(e.pointerId); } catch (x) {} pickSeg(segAt(e.clientX)); });
    barsEl.addEventListener('pointermove', function (e) {
      if (dragging) { pickSeg(segAt(e.clientX)); return; }
      if (!canHover || e.pointerType !== 'mouse') return;
      var i = segAt(e.clientX);
      if (i === state.hover) return;
      state.hover = i; band.classList.add('is-hover');
      BARS.forEach(function (b, k) { b.classList.toggle('is-hov', k === i); });
      refresh();
    });
    var stop = function (e) { if (!dragging) return; dragging = false; try { barsEl.releasePointerCapture(e.pointerId); } catch (x) {} };
    barsEl.addEventListener('pointerup', stop); barsEl.addEventListener('pointercancel', stop);
    barsEl.addEventListener('pointerleave', clearHover);
    barsEl.addEventListener('keydown', function (e) {
      var k = e.key, i = state.seg;
      if (k === 'ArrowRight' || k === 'ArrowUp') i++; else if (k === 'ArrowLeft' || k === 'ArrowDown') i--;
      else if (k === 'Home') i = 0; else if (k === 'End') i = SEGS.length - 1; else if (k === 'PageUp') i += 3; else if (k === 'PageDown') i -= 3; else return;
      e.preventDefault(); pickSeg(i, true);
    });

    /* ---------- Stufe: in der Box und im Planer, beide Richtungen ---------- */
    function setTier(t, fromPlanner) {
      t = slug(t);
      if (!SEASON[t] || t === state.tier) return;
      state.tier = t; paintTier(); refresh(); if (calOpen) renderCal();
      if (!fromPlanner) { try { document.dispatchEvent(new CustomEvent('ms:wann-tier', { detail: { tier: t } })); } catch (e) {} }
    }
    el('tiers').addEventListener('click', function (e) { var b = e.target.closest('button[data-t]'); if (b) setTier(b.getAttribute('data-t')); });
    document.addEventListener('ms:planner-tier', function (e) { if (e.detail && e.detail.tier) setTier(e.detail.tier, true); });
    (function initTier() {
      var u = new URLSearchParams(location.search), t = slug(u.get('ms_tier') || '');
      if (!SEASON[t]) { var on = q('input[data-ms-tier]:checked'); t = on ? slug(on.value) : ''; }
      state.tier = SEASON[t] ? t : 'bronze';
    })();

    /* ---------- Start ---------- */
    var now = new Date();
    state.seg = TODAY_SEG;
    paintTier(); refresh(); moveThumb(view);
    var relayout = function () { paintTier(); moveThumb(view); };
    if (window.ResizeObserver) { new ResizeObserver(relayout).observe(frame); } else { window.addEventListener('resize', relayout); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
    var reveal = function () { band.classList.remove('is-pre'); relayout(); };
    if (reduce() || !window.IntersectionObserver) { reveal(); }
    else { var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); requestAnimationFrame(reveal); } }, { threshold: 0.2 }); io.observe(band); }

    frame.__msWann = { dayInfo: dayInfo, pickSeg: pickSeg, setDate: setDate, setTier: setTier, setView: setView, state: state };
  }

  var boot = function () { qa('[data-ms-wann-root]').forEach(mount); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
